import loadBasketModule from './modules/Basket.module';
const loadBasketPersonalShoppingAdviceModule = () => ({
    hasRouter: false,
    modules: [loadBasketModule()],
});
export default loadBasketPersonalShoppingAdviceModule;
